import { useEffect, useRef } from "react";
import { useAuthContext } from "@/providers/authProvider/authContext";
import { useDialog } from "@/hooks/useDialog";

const FALLBACK_MESSAGE =
  "僅南一會員中心／教育雲之教師或編輯身分登入後才能使用 AI 生成功能";

/**
 * 身份守門：登入者非教師／編輯時，跳出不可略過的阻擋彈窗。
 * 按下確認（或點擊背景）即登出並停留在首頁。
 *
 */
const IdentityGuard = () => {
  const { isForbidden, forbiddenMessage, logout } = useAuthContext();
  const { openDialog } = useDialog();
  const hasShownRef = useRef(false);

  useEffect(() => {
    if (!isForbidden) {
      // 登出後 isForbidden 重置為 false，以便下次登入仍能觸發
      hasShownRef.current = false;
      return;
    }

    if (hasShownRef.current) {
      return;
    }
    hasShownRef.current = true;

    logout();

    openDialog({
      title: "無使用權限",
      content: forbiddenMessage || FALLBACK_MESSAGE,
      confirmText: "確認",
      isShowCloseIcon: false,
    });
  }, [isForbidden, forbiddenMessage, openDialog, logout]);

  return null;
};

export default IdentityGuard;
